export default __webpack_public_path__ + "static/media/curve_mobile.ea0d0e3b.svg";